<template>
    <c-dialog ref="dialog" width="620" mode="slide" mask-close @close="dialogFormEditConfirm($refs.form, arguments)" @resolve="submitHandle">
        <c-form ref="form" vertical unit-width="100%">
            <c-input type="hidden" name="id"></c-input>

            <c-form-item label="单据编号">
                <c-input name="document_number" placeholder="不填，将自动生成"></c-input>
            </c-form-item>

            <c-form-item label="送修资产" required>
                <c-select name="asset_id" v-model="asset_id" async @search="searchAsset" :disabled="fastAdd || editState" :value-data="assetOptions" clearable></c-select>
            </c-form-item>

            <c-form-item label="送修人" required>
                <c-select name="sender_user_id" async @search="searchUser" :value-data="selectedSenderUser" clearable>
                    <template #option="{data, selected}">
                        <select-option
                                :name="data.name"
                                :info="[
                                `${data.data.department_name || ''} | ${data.data.position_name || ''}`
                            ]"
                                :selected="selected"
                        ></select-option>
                    </template>
                </c-select>
            </c-form-item>

            <c-form-item label="送修时间" required>
                <c-datetime name="repair_time" type="datetime" format="yyyy-MM-dd hh:mm"></c-datetime>
            </c-form-item>

            <c-form-item label="维修类型" required>
                <c-select name="repair_type" :options="repairTypeDic"></c-select>
            </c-form-item>

            <c-form-item label="故障描述" required>
                <c-input name="repair_summary" type="textarea" maxlength="500" :rows="3"></c-input>
            </c-form-item>

            <c-form-item label="备注">
                <c-input name="remark" type="textarea" maxlength="500" :rows="3"></c-input>
            </c-form-item>
        </c-form>
    </c-dialog>
</template>

<script>
import {mapState} from "vuex";

export default {
    computed: {
        ...mapState(['userInfo','repairTypeDic'])
    },
    data() {
        return {
            editState: false,
            fastAdd: false,
            selectedSenderUser: [],
            asset_id: 0,
            assetOptions: []
        }
    },
    methods: {
        open(data) {
            this.$refs.form.clear();
            this.editState = false;
            this.fastAdd = false;
            this.selectedSenderUser = [];
            this.asset_id = 0;
            this.assetOptions = [];
            if (data && data.id) {
                this.request({
                    url: '/asset_repair_record/detail',
                    data: {id: data.id},
                    success: detailData => {
                        this.$refs.form.set(detailData);
                        this.asset_id = detailData.asset_id || 0;
                        if (detailData.asset_id && detailData.asset_name) {
                            this.assetOptions = [{name: (detailData.asset_code||'') + ' - ' + detailData.asset_name, value: detailData.asset_id}];
                        }
                        if (detailData.sender_user_id && detailData.sender_user_name) {
                            this.selectedSenderUser = [{name: detailData.sender_user_name, value: detailData.sender_user_id}];
                        }
                    }
                });
                this.editState = true;
            } else {
                this.selectedSenderUser = [{name: this.userInfo.user_realname, value: this.userInfo.id}];
                this.$refs.form.set({sender_user_id: this.userInfo.id});
            }
            this.$refs.dialog.open({
                title: this.editState ? '编辑维修记录' : '新增维修记录'
            });
        },

        add(data) {
            console.log(this.userInfo);
            this.$refs.form.clear();
            this.$refs.form.set({asset_id: data.id});
            this.fastAdd = true;
            this.editState = false;
            this.selectedSenderUser = [{name: this.userInfo.user_realname, value: this.userInfo.id}];
            this.$refs.form.set({sender_user_id: this.userInfo.id});
            this.asset_id = data.id;
            this.assetOptions = [{name: (data.asset_code||'') + ' - ' + data.asset_name, value: data.id}];
            this.$refs.dialog.open({
                title: '新增维修记录'
            });
        },

        searchAsset(keyword, resolve) {
            this.request({
                url: '/fixed_asset/list',
                data: {
                    is_filter_outlet:1,
                    current_status: 1,
                    status: [1],
                    keyword: keyword
                },
                success: data => {

                    resolve(data.map(item => {
                        return {
                            name: (item.asset_code||'') + ' - ' + item.asset_name,
                            value: item.id
                        }
                    }))
                }
            });
        },
        searchUser(keyword, resolve) {
            this.request({
                url: '/system/options',
                data: {
                    options_code: 'SYSUSER',
                    keyword: keyword
                },
                success: data => resolve(data)
            });
        },
        submitHandle(stop, next) {
            stop();

            this.$refs.form.submit({
                url: this.editState ? '/asset_repair_record/edit' : '/asset_repair_record/add',
                rule: {
                    asset_id: '请选择送修资产',
                    sender_user_id: '请选择送修人',
                    repair_time: '请选择送修时间',
                    repair_summary: '请输入维修内容'
                },
                success: () => {
                    next();
                    this.$message({
                        message: this.editState ? '编辑成功' : '新增成功',
                        type: 'success'
                    });
                    this.$emit('resolve');
                }
            });
        }
    }
}
</script>
